import Vue from 'vue';
import Router from 'vue-router';
import Auth from '@aws-amplify/auth';
import { AWSEventBus } from '@bag-era/cognito-authentication';
import Home from './views/Home.vue';
import store from './store';
import SelectEnterpriseView from './views/SelectEnterpriseView.vue';
import ResetPasswordView from './views/ResetPwdView.vue';
import ChangeTmpPwdView from './views/ChangeTmpPwdView.vue';

Vue.use(Router);

/**
 * Weird fix in PWA router for the home index.html path.... fixed with this tip on SO
 * https://stackoverflow.com/questions/53092009/router-part-of-pwa-opens-blank-on-device-with-vue
 */
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: { name: 'home' },
    },
    {
      path: '',
      redirect: { name: 'home' },
    },
    {
      path: '/selectenterprise',
      name: 'selectenterprise',
      component: SelectEnterpriseView,
      meta: { requiresUser: false, requiresEnterprise: false },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/LoginView.vue'),
      meta: { requiresUser: false, requiresEnterprise: true },
    },
    {
      path: '/resetpwd',
      name: 'resetpwd',
      component: ResetPasswordView,
      meta: { requiresUser: false, requiresEnterprise: true },
    },
    {
      path: '/changepwd',
      name: 'changepwd',
      component: ChangeTmpPwdView,
      meta: { requiresUser: false, requiresEnterprise: false },
    },
    {
      path: '/index.html',
      name: 'timesheet',
      component: Home,
      alias: '/home',
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/edit',
      name: 'edit-time-row',
      component: () => import('./views/EditTimeRow.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/create',
      name: 'create-time-row',
      props: true,
      component: () => import('./views/CreateTimeRow.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/surveyshare',
      name: 'survey-share',
      component: () => import('./views/SurveyShare.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/surveyform',
      name: 'survey-form',
      component: () => import('./views/SurveyForm.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('./views/Settings.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/beaconid',
      name: 'beaconid',
      component: () => import('./views/BeaconIdRecord.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/aboutmydatas',
      name: 'aboutmydatas',
      component: () => import('./views/AboutMyDatas.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
  ],
});

router.beforeResolve(async (to, from, next) => {
  // eslint-disable-next-line prefer-destructuring
  const enterprise = store.getters.enterprise;
  const user = store.getters.cognitoUser;
  if (to.matched.some(record => record.meta.requiresEnterprise)) {
    if (!enterprise) {
      return next({
        path: '/selectenterprise',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  if (to.matched.some(record => record.meta.requiresUser)) {
    if (!user) {
      return next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else if (to.path === '/login') {
    if (user) {
      return next({
        path: '/home',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  return next();
});

AWSEventBus.$on('loggedIn', async (data) => {
  const user = {
    username: data.username,
    Session: data.Session,
    info: data.signInUserSession.idToken.payload,
  };
  store.dispatch('setUser', user).then(() => {
    router.push('/home');
  });
});

AWSEventBus.$on('resetPassword', async (data) => {
  router.push({ path: '/resetpwd', query: { username: data.username } });
});

AWSEventBus.$on('pwdChanged', async () => {
  router.push({ path: '/login' });
});

AWSEventBus.$on('changeTmpPassword', async (data) => {
  router.push({ path: '/changepwd', query: { username: data.username, password: data.password } });
});

AWSEventBus.$on('selectEnterprise', async (enterprise) => {
  const awsExports = {
    aws_project_region: enterprise.poolInfo.region,
    aws_cognito_region: enterprise.poolInfo.region,
    aws_user_pools_id: enterprise.poolInfo.userPoolId,
    aws_user_pools_web_client_id: enterprise.poolInfo.clientId,
  };
  Auth.configure(awsExports);
  router.push({ path: '/login' });
});

AWSEventBus.$on('loggedOut', async () => {
  store.dispatch('setUser', null);
  router.push({ path: '/login' });
});

AWSEventBus.$on('changeEnterprise', async () => {
  store.dispatch('setEnterprise', null);
  Auth.configure({});
  router.push({ path: '/selectenterprise' });
});

export default router;
